import React from "react"
import { PerguntaPesquisaSatisfacaoContextProvider } from "./context/PerguntaPesquisaSatisfacaoContextProvider"
import { PerguntaPesquisaSatisfacao } from "./PerguntaPesquisaSatisfacao"

export function Index() {
    return (
        <PerguntaPesquisaSatisfacaoContextProvider>
            <PerguntaPesquisaSatisfacao />
        </PerguntaPesquisaSatisfacaoContextProvider>
    )
}
